<template>
  <div>
    <span class="" :class="{
      'ml-2 float-right': $i18n.locale == 'fa',
      'mr-2 float-left': $i18n.locale != 'fa',
    }">{{ $i18n.locale == "fa" ? vehicle.fa_title : vehicle.en_title }}
      :
    </span>
    <span class="text-xs">{{ license_plate.substring(7, 9) }}</span>
    <span class="text-blue-500 mx-1 font-bold text-xs">|</span>
    <span class="text-xs">{{ license_plate.substring(4, 7) }}</span>
    <span class="mx-1 text-xs">{{ char }}</span>
    <span class="text-xs">{{ license_plate.substring(0, 2) }}</span>
  </div>
</template>
<script>
export default {
  props: {
    license_plate: {
      type: String,
      default: "210122222",
    },
    vehicle: {
      type: Object,
      required: true,
      default(rawProps) {
        return {
          fa_title: "",
          en_title: "",
        };
      },
    },
    chars: {
      type: Array,
      required: true,
      default(rawProps) {
        return [
          {
            char: "",
            code: "",
          },
        ];
      },
    },
  },
  computed: {
    char() {
      return this.chars.find(
        (i) => i.code == this.license_plate.substring(2, 4)
      ) != undefined
        ? this.chars.find((i) => i.code == this.license_plate.substring(2, 4))
          .char
        : "";
    },
  },
};
</script>
